import React from 'react';

function getRent(rents, type) {
  if (!rents.length) {
    return [];
  }
  return rents.reduce((acc, cur) => Math[type](acc, cur), []);
}

class Faq extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    const rents = props.dwellings
      .map(item => item.rent)
      .filter(rent => rent > 0);
    const url = `/${props.city.slug}`;
    const markup = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: `🏘 Hvor mange lejeboliger er der i ${props.city.label}?`,
          acceptedAnswer: {
            '@type': 'Answer',
            text: `Lige nu har vi <a href=${url}>${
              props.meta.results
            } ledige lejeboliger i ${
              props.city.label
            }</a> på Boligninja.dk, men der kommer hele tiden nye til. Du kan tilmelde dig vores BoligAgent for at få emails, hver gang der er nye boliger.`
          }
        },
        {
          '@type': 'Question',
          name: `💰 Hvor høj er huslejen i ${props.city.label}?`,
          acceptedAnswer: {
            '@type': 'Answer',
            text: `De boliger der i øjeblikket er <a href=${url}>ledige i ${
              props.city.label
            }</a> har husleje fra ${getRent(rents, 'min')} til ${getRent(
              rents,
              'max'
            )}.`
          }
        },
        {
          '@type': 'Question',
          name: `⚡ Hvor hurtigt kan man få bolig i ${props.city.label}?`,
          acceptedAnswer: {
            '@type': 'Answer',
            text: `I ${
              props.city.label
            } har vi kun <a href=${url}>boliger med ingen eller meget kort ventetid</a>, så det er som regel muligt at få bolig fra starten af de kommende måneder.`
          }
        }
      ]
    };
    return (
      <>
        {markup.mainEntity.map((entity, idx) => {
          return (
            <div
              key={idx}
              itemScope
              itemProp="mainEntity"
              itemType={`https://schema.org/${entity['@type']}`}
            >
              <h3 itemProp="name">{entity.name}</h3>
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType={`https://schema.org/${
                  entity.acceptedAnswer['@type']
                }`}
              >
                <div
                  itemProp="text"
                  dangerouslySetInnerHTML={{
                    __html: entity.acceptedAnswer.text
                  }}
                />
              </div>
            </div>
          );
        })}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(markup) }}
        />
      </>
    );
  }
}

export default Faq;
